import * as api from '../../api/api-proceso-extrajudicial';
import { 
    GET_CONFIG_FORM14,
    GET_DATOS_GESTION_IMPLICADO,
    GET_COMBO_REGISTRAR_HITOS,
    POST_ACTUALIZAR_EXTRAJUDICIAL,
    GET_LISTA_IMPLICADOS,
    GET_DATOS_GESTION_IMPLICADO_DEFAULT
    
} from '../types';


export const configuracionFormAction14 = (query) => ({
    type: GET_CONFIG_FORM14,
    payload: api.getConfiguracionForm14(query)
});
export const obtenerDatosGestionImplicado = (query) => ({
    type: GET_DATOS_GESTION_IMPLICADO,
    payload: api.getDatosGestionImpicado(query)
});
export const obtenerComboRegistrarHitos = (query) => ({
    type: GET_COMBO_REGISTRAR_HITOS,
    payload: api.getComboRegistrarHito(query)
});
export const actualizarExtrajudicial = (newReg) => ({
    type: POST_ACTUALIZAR_EXTRAJUDICIAL,
    payload: api.actualizarProcesoExtrajudicial(newReg)
});
export const obtenerListaImplicados = (query) => ({
    type: GET_LISTA_IMPLICADOS,
    payload: api.getListaImplicado(query)
});
export const obtenerDatosGestionImplicadoDefault = (query) => ({
    type: GET_DATOS_GESTION_IMPLICADO_DEFAULT,
    payload: api.getDatosGestionImpicado(query)
});